function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3;
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { customElement as p } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as m } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import { NgcComponent as d } from "../../../utils/components/ngc-component.js";
import f from "../../../packages/web-components/src/components/time-picker/gator/time-picker.gator.scss.js";
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as h } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import { LitElement as g } from "../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { msg as s } from "../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/install.js";
import "../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/runtime.js";
import { zeroPad as v } from "../../../utils/string-utils.js";
import { KEY_CONSTANTS as r } from "../../../consts/key-constants.js";
import "../../selector/gator/selector.gator.js";
import "../../icon-button/gator/icon-button.gator.js";
import "../../button/gator/button.gator.js";
import { unsafeCSS as b } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var y = Object.defineProperty,
  k = Object.getOwnPropertyDescriptor,
  w = Object.getPrototypeOf,
  O = Reflect.get,
  l = function l(e, t, i, n) {
    for (var o = n > 1 ? void 0 : n ? k(t, i) : t, a = e.length - 1, u; a >= 0; a--) (u = e[a]) && (o = (n ? u(t, i, o) : u(o)) || o);
    return n && o && y(t, i, o), o;
  },
  $ = function $(e, t, i) {
    return O(w(e), i, t);
  };
var c = /*#__PURE__*/function (_d) {
  function c() {
    var _this;
    _classCallCheck(this, c);
    _this = _callSuper(this, c, arguments), _this.hour = null, _this.minute = null, _this.timeOfDay = null;
    return _this;
  }
  _inherits(c, _d);
  return _createClass(c, [{
    key: "updated",
    value: function () {
      var _updated = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _superPropGet(c, "updated", this, 3)([e]), (e.has("hour") || e.has("minute")) && (!this.hour && !this.minute && this.setToCurrentTime(), this.scrollToOptions());
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updated(_x) {
        return _updated.apply(this, arguments);
      }
      return updated;
    }()
  }, {
    key: "firstUpdated",
    value: function firstUpdated(e) {
      !this.hour && !this.minute && this.setToCurrentTime(), this.scrollToOptions();
    }
  }, {
    key: "setToCurrentTime",
    value: function setToCurrentTime() {
      var e = new Date();
      this.hour = e.getHours() % 12 || 12, this.minute = e.getMinutes();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return h(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div class=\"gator-time-picker\" role=\"dialog\" aria-modal=\"true\" aria-label=\"", "\" @keydown=\"", "\">\n                <div class=\"gator-time-picker-selection\">\n                    <div class=\"gator-time-picker-hours\">\n                        <div class=\"gator-time-picker-header\">\n                            hh\n                        </div>\n                        <div class=\"gator-time-picker-chevron\">\n                            <ngc-icon-button\n                                @click=\"", "\"\n                                aria-label=\"", "\"\n                                size=\"medium\"\n                                icon-name=\"chevron-up\"\n                                tabindex=\"-1\"\n                            ></ngc-icon-button>\n                        </div>\n                        <div class=\"gator-time-picker-options\" tabindex=\"-1\" role=\"listbox\"  aria-label=\"", "\">\n                            ", "\n                        </div>\n                        <div class=\"gator-time-picker-chevron\">\n                            <ngc-icon-button\n                                @click=\"", "\"\n                                aria-label=\"", "\"\n                                size=\"medium\"\n                                icon-name=\"chevron-down\"\n                                tabindex=\"-1\"\n                            ></ngc-icon-button>\n                        </div>\n                    </div>\n                    <div class=\"gator-time-picker-minutes\">\n                        <div class=\"gator-time-picker-header\">\n                            mm\n                        </div>\n                        <div class=\"gator-time-picker-chevron\">\n                            <ngc-icon-button\n                                @click=\"", "\"\n                                aria-label=\"", "\"\n                                size=\"medium\"\n                                icon-name=\"chevron-up\"\n                                tabindex=\"-1\"\n                            ></ngc-icon-button>\n                        </div>\n                        <div class=\"gator-time-picker-options\" tabindex=\"-1\" role=\"listbox\" aria-label=\"", "\">\n                            ", "\n                        </div>\n                        <div class=\"gator-time-picker-chevron\">\n                            <ngc-icon-button\n                                @click=\"", "\"\n                                aria-label=\"", "\"\n                                size=\"medium\"\n                                icon-name=\"chevron-down\"\n                                tabindex=\"-1\"\n                            ></ngc-icon-button>\n                        </div>\n                    </div>\n                    <div class=\"gator-time-picker-time-of-day\">\n                        <div class=\"gator-time-picker-header\"></div>\n                        <div class=\"gator-time-picker-options\" tabindex=\"-1\" role=\"listbox\"  aria-label=\"", "\">\n                            <ngc-selector\n                                role=\"option\"\n                                aria-label=\"PM\"\n                                type=\"base\"\n                                ?selected=\"", "\"\n                                tabindex=\"", "\"\n                                @select=\"", "\"\n                                @keydown=\"", "\"\n                            >\n                                PM\n                            </ngc-selector>\n                            <ngc-selector\n                                role=\"option\"\n                                aria-label=\"AM\"\n                                type=\"base\"\n                                ?selected=\"", "\"\n                                tabindex=\"", "\"\n                                @select=\"", "\"\n                                @keydown=\"", "\"\n                            >\n                                AM\n                            </ngc-selector>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"gator-time-picker-actions\">\n                    <div class=\"gator-time-picker-clear\">\n                        <ngc-button variant=\"base\" @click=\"", "\">\n                            ", "\n                        </ngc-button>\n                    </div>\n                    <div class=\"gator-time-picker-now\">\n                        <ngc-button\n                            variant=\"base\"\n                            @click=\"", "\"\n                            @keydown=\"", "\"\n                        >\n                          ", "\n                        </ngc-button>\n                    </div>\n                </div>\n            </div>\n        "])), s("Select Time"), this.handleTopLevelKeyUp, this.selectPreviousHour, s("Previous Hour"), s("Hour Options"), this.hourOptions, this.selectNextHour, s("Next Hour"), this.selectPreviousMinute, s("Previous Minute"), s("Minute Options"), this.minuteOptions, this.selectNextMinute, s("Next Minute"), s("Time of Day Options"), this.timeOfDay === "PM", this.pmShouldBeTabbable ? "0" : "-1", function (e) {
        return _this2.handleSelectionChange(e, "timeOfDay");
      }, this.focusOtherTimeOfDayOption, this.timeOfDay === "AM", this.timeOfDay === "AM" ? "0" : "-1", function (e) {
        return _this2.handleSelectionChange(e, "timeOfDay");
      }, this.focusOtherTimeOfDayOption, this.sendClearEvent, s("Clear"), this.sendNowEvent, this.handleNowButtonKeyDown, s("Now"));
    }
  }, {
    key: "pmShouldBeTabbable",
    get: function get() {
      return this.timeOfDay ? this.timeOfDay === "PM" ? "0" : "-1" : !0;
    }
  }, {
    key: "scrollToOptions",
    value: function scrollToOptions() {
      var _this$shadowRoot, _this$shadowRoot2;
      var e = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelector(".gator-time-picker-hours ngc-selector[selected]");
      e && e.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      var t = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.querySelector(".gator-time-picker-minutes ngc-selector[selected]");
      t && t.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, {
    key: "hourOptions",
    get: function get() {
      var _this3 = this;
      return Array.from({
        length: 12
      }, function (t, i) {
        return i + 1;
      }).map(function (t) {
        var i = v(t, 2),
          n = _this3.hour == t || _this3.hour === 0 && t === 12;
        var o = -1;
        return (_this3.hour === t || _this3.hour === null) && (o = 0), h(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                <ngc-selector\n                    role=\"option\"\n                    type=\"base\"\n                    data-value=\"", "\"\n                    ?selected=\"", "\"\n                    @select=\"", "\"\n                    tabindex=\"", "\"\n                    @keydown=\"", "\"\n                >\n                    ", "\n                </ngc-selector>\n            "])), i, n, function (a) {
          return _this3.handleSelectionChange(a, "hour");
        }, o, _this3.handleHourKeyDown, i);
      });
    }
  }, {
    key: "minuteOptions",
    get: function get() {
      var _this4 = this;
      return Array.from({
        length: 60
      }, function (t, i) {
        return i + 1;
      }).map(function (t) {
        var i = t - 1,
          n = i - 1 < 9 ? "0".concat(i) : i;
        return h(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                <ngc-selector\n                    role=\"option\"\n                    type=\"base\"\n                    data-value=\"", "\"\n                    ?selected=\"", "\"\n                    @select=\"", "\"\n                    tabindex=\"", "\"\n                    @keydown=\"", "\"\n                >\n                    ", "\n                </ngc-selector>\n            "])), n, _this4.minute === i, function (o) {
          return _this4.handleSelectionChange(o, "minute");
        }, _this4.minute === i ? "0" : "-1", _this4.handleMinuteKeyDown, n);
      });
    }
  }, {
    key: "handleMinuteKeyDown",
    value: function handleMinuteKeyDown(e) {
      e.key == r.UP && (e.stopPropagation(), e.preventDefault(), this.focusPreviousMinute()), e.key == r.DOWN && (e.stopPropagation(), e.preventDefault(), this.focusNextMinute());
    }
  }, {
    key: "handleHourKeyDown",
    value: function handleHourKeyDown(e) {
      if (e.key == r.TAB && e.shiftKey) {
        var _this$shadowRoot3;
        e.preventDefault();
        var t = (_this$shadowRoot3 = this.shadowRoot) === null || _this$shadowRoot3 === void 0 ? void 0 : _this$shadowRoot3.querySelector(".gator-time-picker-now ngc-button");
        t && t.focus();
      }
      e.key == r.UP && (e.stopPropagation(), e.preventDefault(), this.focusPreviousHour()), e.key == r.DOWN && (e.stopPropagation(), e.preventDefault(), this.focusNextHour());
    }
  }, {
    key: "selectNextHour",
    value: function selectNextHour() {
      if (this.hour && this.hour < 12) {
        var e = this.hour + 1;
        this.handleSelectionChange(new CustomEvent("change", {
          detail: {
            value: e
          }
        }), "hour");
      }
    }
  }, {
    key: "selectPreviousHour",
    value: function selectPreviousHour() {
      if (this.hour && this.hour > 1) {
        var e = this.hour - 1;
        this.handleSelectionChange(new CustomEvent("change", {
          detail: {
            value: e
          }
        }), "hour");
      }
    }
  }, {
    key: "selectNextMinute",
    value: function selectNextMinute() {
      if (this.minute != null && this.minute < 59) {
        var e = this.minute + 1;
        this.handleSelectionChange(new CustomEvent("change", {
          detail: {
            value: e
          }
        }), "minute");
      }
    }
  }, {
    key: "selectPreviousMinute",
    value: function selectPreviousMinute() {
      if (this.minute != null) {
        var e = this.minute - 1;
        this.handleSelectionChange(new CustomEvent("change", {
          detail: {
            value: e
          }
        }), "minute");
      }
    }
  }, {
    key: "handleSelectionChange",
    value: function handleSelectionChange(e, t) {
      e.stopPropagation(), e.preventDefault();
      var i = e.detail.value;
      this.dispatchEvent(new CustomEvent("change", {
        bubbles: !1,
        composed: !0,
        detail: _defineProperty({}, t, i)
      }));
    }
  }, {
    key: "focusNextHour",
    value: function focusNextHour() {
      var _this$shadowRoot4;
      var e = (_this$shadowRoot4 = this.shadowRoot) === null || _this$shadowRoot4 === void 0 ? void 0 : _this$shadowRoot4.querySelector(".gator-time-picker-hours .gator-time-picker-options ngc-selector[tabindex='0']");
      if (e) {
        var t = e.nextElementSibling;
        t && this.focusNewOption(t, e);
      }
    }
  }, {
    key: "focusPreviousHour",
    value: function focusPreviousHour() {
      var _this$shadowRoot5;
      var e = (_this$shadowRoot5 = this.shadowRoot) === null || _this$shadowRoot5 === void 0 ? void 0 : _this$shadowRoot5.querySelector(".gator-time-picker-hours .gator-time-picker-options ngc-selector[tabindex='0']");
      if (e) {
        var t = e.previousElementSibling;
        t && this.focusNewOption(t, e);
      }
    }
  }, {
    key: "focusNextMinute",
    value: function focusNextMinute() {
      var _this$shadowRoot6;
      var e = (_this$shadowRoot6 = this.shadowRoot) === null || _this$shadowRoot6 === void 0 ? void 0 : _this$shadowRoot6.querySelector(".gator-time-picker-minutes .gator-time-picker-options ngc-selector[tabindex='0']");
      if (e) {
        var t = e.nextElementSibling;
        t && this.focusNewOption(t, e);
      }
    }
  }, {
    key: "focusPreviousMinute",
    value: function focusPreviousMinute() {
      var _this$shadowRoot7;
      var e = (_this$shadowRoot7 = this.shadowRoot) === null || _this$shadowRoot7 === void 0 ? void 0 : _this$shadowRoot7.querySelector(".gator-time-picker-minutes .gator-time-picker-options ngc-selector[tabindex='0']");
      if (e) {
        var t = e.previousElementSibling;
        t && this.focusNewOption(t, e);
      }
    }
  }, {
    key: "focusNewOption",
    value: function focusNewOption(e, t) {
      t.setAttribute("tabindex", "-1"), e.setAttribute("tabindex", "0"), e.focus(), e.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, {
    key: "focusOtherTimeOfDayOption",
    value: function focusOtherTimeOfDayOption(e) {
      var _this$shadowRoot8;
      if (e.key != r.DOWN && e.key != r.UP) return;
      e.stopPropagation(), e.preventDefault();
      var t = (_this$shadowRoot8 = this.shadowRoot) === null || _this$shadowRoot8 === void 0 ? void 0 : _this$shadowRoot8.querySelector(".gator-time-picker-time-of-day ngc-selector[tabindex='0']");
      if (t) {
        var i = null;
        e.key == r.DOWN ? i = t.nextElementSibling : i = t.previousElementSibling, i && this.focusNewOption(i, t);
      }
    }
  }, {
    key: "sendClearEvent",
    value: function sendClearEvent() {
      this.dispatchEvent(new CustomEvent("clear", {
        composed: !0
      }));
    }
  }, {
    key: "sendNowEvent",
    value: function sendNowEvent() {
      this.dispatchEvent(new CustomEvent("now", {
        composed: !0
      }));
    }
  }, {
    key: "handleNowButtonKeyDown",
    value: function handleNowButtonKeyDown(e) {
      e.key == r.TAB && !e.shiftKey && (e.preventDefault(), this.selectedHourElement && this.selectedHourElement.focus());
    }
  }, {
    key: "selectedHourElement",
    get: function get() {
      var _this$shadowRoot9;
      return (_this$shadowRoot9 = this.shadowRoot) === null || _this$shadowRoot9 === void 0 ? void 0 : _this$shadowRoot9.querySelector(".gator-time-picker-hours ngc-selector[selected]");
    }
  }, {
    key: "firstHourElement",
    get: function get() {
      var _this$shadowRoot0;
      return (_this$shadowRoot0 = this.shadowRoot) === null || _this$shadowRoot0 === void 0 ? void 0 : _this$shadowRoot0.querySelector(".gator-time-picker-hours ngc-selector");
    }
  }, {
    key: "focus",
    value: function focus() {
      this.selectedHourElement ? this.selectedHourElement.focus() : this.firstHourElement.focus();
    }
  }, {
    key: "handleTopLevelKeyUp",
    value: function handleTopLevelKeyUp(e) {
      e.key == r.ESCAPE && (e.stopPropagation(), e.preventDefault(), this.dispatchEvent(new CustomEvent("close", {
        composed: !0
      })));
    }
  }]);
}(d);
c.shadowRootOptions = _objectSpread(_objectSpread({}, g.shadowRootOptions), {}, {
  delegatesFocus: !0
});
c.styles = [].concat(_toConsumableArray($(c, c, "styles")), [b(f)]);
l([m({
  type: Number
})], c.prototype, "hour", 2);
l([m({
  type: Number
})], c.prototype, "minute", 2);
l([m({
  attribute: "time-of-day"
})], c.prototype, "timeOfDay", 2);
c = l([p("ngc-time-picker")], c);
export { c as NgcTimePicker };